<template>
  <div>
    <AppHeader />
    <div class="activities">
      <div class="activities__preview">
        <v-container class="activities__preview-inner white--text">
          <v-layout>
            <v-flex>
              <h2 class="activities__preview-title">
                NMG Charity Challenge 
              </h2>
              <h3 class="activities__preview-title">
                Making it Count <a href="https://web.yammer.com/main/org/nmg-group.com/search/threads?search=%23allforthekids">#forthechildren</a>
              </h3>
              <v-form class="activities_search-form">
                <div class="activities_search-inner">
                  <v-autocomplete
                    v-model="searchActivity"
                    :items="getActivities"
                    item-value="id"
                    item-text="name"
                    label="Search activities"
                    height="56px"
                    single-line
                    solo
                    depressed
                    clearable
                    color="teal lighten-2"
                    prepend-inner-icon="fas fa-search fa-1x"
                  />
                </div>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </div>

      <v-container>
        <v-layout row class="article-layout-start">
          <v-flex md12>
            <h2 class="app-title">
              My Favourites
              <router-link to="search" class="title-link">
                See all activities
                <i class="fas fa-chevron-right" />
              </router-link>
            </h2>

            <!-- swiper -->
            <swiper v-if="loaded" :options="swiperOption">
              <swiper-slide
                v-for="activity in filteredActivities"
                :key="activity.id"
                class="activities-slider"
              >
                <router-link
                  class="popular_slide"
                  :to="{ name: 'activity', params: { id: activity.id } }"
                >
                  <v-card>
                    <v-img
                      class="white--text"
                      height="150px"
                      :src="activity.image"
                    />
                    <v-card-title>
                      <span class="activity-name">{{ activity.name }}</span>
                    </v-card-title>
                  </v-card>
                </router-link>
              </swiper-slide>
            </swiper>
            <div v-else class="text-xs-center">
              <v-progress-circular :size="50" color="primary" indeterminate />
            </div>
          </v-flex>
        </v-layout>

        <v-layout row class="article-layout">
          <v-flex>
            <h2 class="app-title">
              NMG’s CHARITY CHALLENGE
            </h2>

            <p style="text-align: justify;">
              An annual fundraising event for employees, alumni and family. For
              three months, from 1 June to 31 August teams across the NMG Group
              run, walk, swim, cycle and participate in sports to earn “miles”
              that are translated into a corporate donation to a select group of
              charities that support vulnerable children.
            </p>
          </v-flex>
        </v-layout>
        <v-layout row class="article-layout">
          <v-flex md12>
            <h2 class="app-title">
              Leaderboard
            </h2>

            <v-card to="leaderboard">
              <v-img
                class="white--text"
                height="100px"
                :src="require('../assets/leaderboard.jpg')"
              />
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout row class="article-layout-bottom">
          <v-flex md12>
            <h2 class="app-title">
              Getting Started
            </h2>

            <v-card to="articles">
              <v-img
                class="white--text"
                height="100px"
                :src="require('../assets/articles.jpg')"
              >
                <v-container fluid>
                  <v-layout fill-height>
                    <v-flex xs12 align-end flexbox>
                      <h3>
                        News
                      </h3>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <BottomNavigation />
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import AppHeader from "../components/AppHeader";
import BottomNavigation from "../components/BottomNavigation";
///import { ACTIVITIES_REQUEST } from '../store/actions/activities';
import "swiper/dist/css/swiper.css";
import { mapGetters } from "vuex";

export default {
  name: "Activities",
  components: {
    swiper,
    swiperSlide,
    AppHeader,
    BottomNavigation
  },
  data() {
    return {
      searchActivity: "",
      loaded: false,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 20,
        // init: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters("activity", ["getActivities"]),
    //activityOptions: function () {
    //   return this.$store.getters.getActivities;
    // },
    filteredActivities: function() {
      if (this.searchActivity) {
        return this.getActivities.filter(
          activity => activity.id === this.searchActivity
        );
      }
      return this.getActivities;
    }
  },
  mounted() {
    this.$store
      .dispatch("activity/activitiesRequest")
      .then(() => {
        this.loaded = true;
      })
      .catch(err => {});
  }
};
</script>

<style scoped>
.activities__preview {
  display: flex;
  /* padding: 45px 0; */
  background-color: #272727;
  margin-bottom: 60px;
}

h2.activities__preview-title {
  font-size: 25px;
  line-height: 35px;
  padding: 0 15px;
}
h3.activities__preview-title {
  line-height: 35px;
  padding: 0 15px;
}

.activities__preview-inner {
  position: relative;
  display: flex;
  height: 100%;
  padding-bottom: 30px;
}

.v-text-field.v-text-field--enclosed {
  margin-top: -45px;
}
.layout.article-layout-start.row {
  margin-top: -20px;
  margin-bottom: 50px;
}

.activities_search-form {
  position: absolute;
  bottom: -75px;
  left: 0;
  width: 100%;
  padding: 0 15px;
}

.activities_search-inner {
  display: flex;
  width: 100%;
  height: 56px;
}

.activities_search-input {
  width: calc(100% - 56px);
  background-color: #fff;
  margin: 0;
  height: 100%;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  padding: 0 15px;
  color: #6e8ca0;
  outline: none;
}

.activities_search-button {
  position: relative;
  left: -2px;
  width: 56px;
  height: 100%;
  margin: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.popular_slide {
  display: block;
  margin: 5px;
  text-decoration: none;
  text-align: center;
}
.v-progress-circular {
  margin: 1rem;
}

.article-layout {
  margin-bottom: 15px;
}
.article-layout-bottom {
  margin-bottom: 100px;
}

.swiper-container {
  margin-bottom: -40px;
}

.activity-name {
  height: 25px;
  overflow: hidden;
}
</style>
